import React from 'react';
import path from 'public/landing/journey-filigrane.png';
import step1 from 'public/landing/step-01.png';
import step2 from 'public/landing/step-02.png';
import step3 from 'public/landing/step-03.png';
import step4 from 'public/landing/step-04.png';

const steps = [
  [
    step1,
    'Création du compte',
    'Créez votre compte pèlerin et renseignez vos informations pour débuter votre inscription au Hadj.',
  ],
  [
    step2,
    'Choix de la catégorie et de l’agence',
    'Sélectionnez votre catégorie et votre agence agréée pour poursuivre votre inscription.',
  ],
  [step3, 'Paiement et validation', 'Effectuez les paiements requis et suivez la validation de votre dossier.'],
  [
    step4,
    'Suivi et préparation',
    'Retrouvez les informations importantes pour suivre votre inscription et préparer votre pèlerinage.',
  ],
];
const Journey = () => (
  <section
    className="bg-[#00472f] pb-5 pt-11 text-center text-white min-[681px]:pb-6 min-[681px]:pt-16 [&_h2]:mx-auto [&_h2]:mb-[18px] [&_h2]:max-w-[850px]"
    aria-labelledby="journey-title"
  >
    <div className="mx-auto w-[calc(100%-40px)] min-[681px]:w-[calc(100%-56px)] min-[1001px]:w-[calc(100%-112px)] max-w-[1230px] [&>p]:text-[#dce7df]">
      <h2 id="journey-title" className="font-semibold leading-[1.3] text-inherit text-[25px] min-[681px]:text-[30px]">
        Les étapes clés de votre inscription au Hadj via eHadj
      </h2>
      <p className="text-base leading-[inherit] text-inherit">
        La plateforme eHadj simplifie vos démarches liées au pèlerinage.
        <br />
        En quelques étapes, suivez votre dossier et préparez votre Hadj en toute sérénité.
      </p>
      <div className="relative mt-[25px] [container-type:inline-size]">
        <img
          className="pointer-events-none absolute -top-[8.13cqw] -left-[4.55%] z-0 hidden h-auto w-[109.1%] max-w-none opacity-[0.85] min-[1001px]:block"
          src={path}
          alt=""
          aria-hidden="true"
          width="1707"
          height="620"
          loading="lazy"
        />
        <ol className="relative z-[1] grid list-none grid-cols-1 items-start gap-9 pb-[35px] pt-4 text-center min-[681px]:grid-cols-2 min-[681px]:text-left min-[1001px]:min-h-[620px] min-[1001px]:grid-cols-[2fr_20fr_5fr_20fr_7fr_20fr_5fr_20fr_1fr] min-[1001px]:gap-0 min-[1001px]:pt-0">
          {steps.map(([image, title, copy], index) => (
            <li
              key={title}
              className="min-[1001px]:first:col-start-2 min-[1001px]:first:mt-[6.5cqw] min-[1001px]:[&:nth-child(2)]:col-start-4 min-[1001px]:[&:nth-child(2)]:mt-[15.45cqw] min-[1001px]:[&:nth-child(3)]:col-start-6 min-[1001px]:[&:nth-child(3)]:mt-[10.15cqw] min-[1001px]:last:col-start-8 min-[1001px]:last:mt-[15.45cqw]"
            >
              <img
                className="h-[230px] max-h-[255px] w-full object-contain min-[1001px]:h-[17.9cqw]"
                src={image}
                alt=""
                width="335"
                height="357"
                loading="lazy"
              />
              <span className="mt-3 block text-[25px] font-semibold">0{index + 1}</span>
              <h3 className="mx-auto my-2.5 text-[17px] font-semibold leading-[1.3] text-inherit">{title}</h3>
              <p className="mx-auto max-w-[290px] text-sm leading-[1.8] text-[#dce7df]">{copy}</p>
            </li>
          ))}
        </ol>
      </div>
    </div>
  </section>
);
export default Journey;
